import { createApp  } from 'vue';
import App from './App.vue';
import router from './router';
import { createI18n } from 'vue-i18n';
import { createPinia } from 'pinia';
import messages from './translations.js';

//import '@/assets/fabric11.min.css';
//import '@/assets/fabric.min.css';
//import "font-awesome/css/font-awesome.min.css";
import "umaui/dist/style.css";


const urlParams = new URLSearchParams(window.location.search);
const rootProps = {
    language: window.currentLanguage,
    baseUrl: window.siteUrl,
    themePath: window.themePath,
    apipath: window.apipath,
    cursoid: urlParams.get("cursoid"),
    faculdadeid: urlParams.get("faculdadeid")
}

export const i18n = createI18n({
    messages,
    locale: window.lang || 'en', 
});

const pinia = createPinia();

const app = createApp(App,rootProps);
app.use(router);
app.use(pinia);
app.use(i18n);
app.mount('#app');
